export default __webpack_public_path__ + "static/media/signature.d80aabc8.png";